var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","color":_vm.$colors.purple},on:{"click":_vm.handleButton}},[_vm._v(" "+_vm._s(_vm.dates[_vm.exampleStepper].message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }